import api from "../../system/api";
import {getStorage} from "../../system/storage";

// Project dashboard tab (backend: src/projects/dashboard.ts in zofino-strapi; docs/tasks/22-project-dashboard.md).
const data = (response) => response?.data?.data;
const config = (extra = {}) => ({headers: {workspace: getStorage("workspace")}, ...extra});

export const projectDashboardApi = {
    get: async (project, range = "30") => data(await api.get(`/project-dashboard/${project}`, config({params: {range}}))),
    // the identity tab's progress chart: {milestones, doneMilestones, current, points: [{at, progress}]}
    milestoneProgress: async (project) => data(await api.get(`/project-dashboard/${project}/milestone-progress`, config({suppressGlobalErrorHandler: true}))),
    // «بررسی شد، فعلاً مشکلی نیست»: the risk's score and signals are stored so it shows again when it gets worse
    review: async (project, item) => data(await api.post(`/project-dashboard/${project}/reviews`, {data: {
        entityType: item.entityType,
        entityId: item.entityId,
        score: item.risk?.score || 0,
        signalTypes: (item.risk?.signals || []).map((signal) => signal.type),
    }}, config())),
    createFollowUp: async (project, followUp) => data(await api.post(`/project-dashboard/${project}/follow-ups`, {data: followUp}, config({suppressGlobalErrorHandler: true}))),
    closeFollowUp: async (project, documentId, status = "done") => data(await api.put(`/project-dashboard/${project}/follow-ups/${documentId}`, {data: {status}}, config())),
};
